// Centralized data-testids for UTMEDIA landing page
export const TID = {
  // Nav
  navRoot: 'nav-root',
  navLogo: 'nav-logo',
  navLinkWork: 'nav-link-work',
  navLinkServices: 'nav-link-services',
  navLinkAbout: 'nav-link-about',
  navLinkContact: 'nav-link-contact',
  navLinkPortfolio: 'nav-link-portfolio',
  navCta: 'nav-cta',

  // Hero
  heroRoot: 'hero-root',
  heroTitle: 'hero-title',
  heroSub: 'hero-sub',
  heroScrollHint: 'hero-scroll-hint',
  heroCtaWork: 'hero-cta-work',

  // Reels
  reelsRoot: 'reels-root',
  reel: (i) => `reel-${i}`,
  reelMuteToggle: (i) => `reel-mute-${i}`,

  // Packages
  packagesRoot: 'packages-root',
  packageCard: (key) => `package-card-${key}`,
  packageCta: (key) => `package-cta-${key}`,

  // About
  aboutRoot: 'about-root',

  // Contact
  contactRoot: 'contact-root',
  contactForm: 'contact-form',
  contactName: 'contact-name',
  contactEmail: 'contact-email',
  contactProjectType: 'contact-project-type',
  contactBudget: 'contact-budget',
  contactMessage: 'contact-message',
  contactSubmit: 'contact-submit',
  contactSuccess: 'contact-success',
  contactError: 'contact-error',

  // Contact modal (popup)
  contactModal: 'contact-modal',
  modalName: 'modal-contact-name',
  modalEmail: 'modal-contact-email',
  modalProjectType: 'modal-contact-project-type',
  modalBudget: 'modal-contact-budget',
  modalMessage: 'modal-contact-message',
  modalSubmit: 'modal-contact-submit',
  modalSuccess: 'modal-contact-success',

  // Hero particles
  heroParticles: 'hero-particles',

  // Footer legal
  footerPrivacy: 'footer-privacy-link',
  footerTerms: 'footer-terms-link',
  privacyModal: 'privacy-modal',
  termsModal: 'terms-modal',

  // Footer
  footerRoot: 'footer-root',
  footerEmail: 'footer-email',

  // Portfolio page
  portfolioRoot: 'portfolio-root',
  portfolioBackHome: 'portfolio-back-home',
  portfolioTab: (key) => `portfolio-tab-${key}`,
  portfolioComingSoon: 'portfolio-coming-soon',
  portfolioCarousel: 'portfolio-carousel',
  portfolioSlide: (i) => `portfolio-slide-${i}`,
  portfolioPrev: 'portfolio-prev',
  portfolioNext: 'portfolio-next',
  portfolioMute: 'portfolio-mute',
  portfolioExpand: 'portfolio-expand',
  portfolioLightbox: 'portfolio-lightbox',
  portfolioLightboxClose: 'portfolio-lightbox-close',
  portfolioLightboxPrev: 'portfolio-lightbox-prev',
  portfolioLightboxNext: 'portfolio-lightbox-next',
  portfolioDot: (i) => `portfolio-dot-${i}`,
  portfolioViewAll: 'portfolio-view-all',
};
